import type { OrderLinkResponseItem } from './types';

export function getOrderLinkUrl(orderLink: OrderLinkResponseItem): string | undefined {
    const { bulkId, dataCarrierId, bundleId } = orderLink;
    const root = '/payments/payment-orders/detail';

    if (bulkId && dataCarrierId && bundleId) {
        return `${root}/bundle/${bundleId}/data-carrier/${dataCarrierId}/bulk/${bulkId}`;
    }

    if (bulkId && dataCarrierId) {
        return `${root}/data-carrier/${dataCarrierId}/bulk/${bulkId}`;
    }

    if (bulkId && bundleId) {
        return `${root}/bundle/${bundleId}/bulk/${bulkId}`;
    }

    if (bulkId) {
        return `${root}/bulk/${bulkId}`;
    }

    return undefined;
}
